<div class="content" *ngIf="totais">
  <div class="p-grid p-fluid">
    <div class="p-col-12 p-md-6">
      <p>
        <span class="value">{{ totais?.login?.acessaramUltimos5 }}</span>
        acessaram nos últimos <strong>5 dias</strong>
      </p>
      <p>
        <span class="value">{{ totais?.login?.naoAcessaramUltimos15 }}</span>
        não acessam há mais de <strong>15 dias</strong>
      </p>
      <p>
        <span class="value">{{ totais.cadastro }}</span> fizeram cadastros
      </p>
      <p>
        <span class="value">{{ totais.lancamento }}</span> fizeram lançamentos
        financeiros
      </p>
      <p>
        <span class="value">{{ totais.comercial }}</span> fizeram movimento
        comercial
      </p>
      <p>
        <span class="value">{{ totais.servico }}</span> fizeram prestações de
        serviço
      </p>
    </div>

    <div class="p-col-12 p-md-6">
      <p>
        <span class="value">{{
          totais?.total - totais?.login?.acessaramUltimos5
        }}</span>
        não acessaram nos últimos <strong>5 dias</strong>
      </p>
      <p>
        <span class="value">{{ totais?.login?.acessaramUltimos15 }}</span>
        acessaram nos últimos <strong>15 dias</strong>
      </p>
      <p>
        <span class="value">{{ totais.total - totais.cadastro }}</span> não
        fizeram cadastros
      </p>
      <p>
        <span class="value">{{ totais.total - totais.lancamento }}</span> não
        fizeram lançamentos financeiros
      </p>
      <p>
        <span class="value">{{ totais.total - totais.comercial }}</span> não
        fizeram movimento comercial
      </p>
      <p>
        <span class="value">{{ totais.total - totais.servico }}</span> não
        fizeram prestações de serviço
      </p>
    </div>
  </div>
  <hr />
  <div class="p-grid p-fluid">
    <div class="p-col"></div>
    <div class="p-col-2">
      <button
        pButton
        pRippler
        label="Exportar"
        class="botao-acao"
        (click)="exportar()"
      ></button>
    </div>
  </div>
</div>
<div class="content" *ngIf="!totais">
  <p>Carregando dados...</p>
</div>
